export type Email = string;
export type Password = string;
export type DataVersion = number;
// 対応するロケールに応じて増やしていく
export const Locales = ['ja', 'en', 'vi', 'id'] as const;
type LocaleTuple = typeof Locales;
export type Locale = LocaleTuple[number];
